import * as actionTypes from '../../actions/actionTypes';

export const initialState = {
  byId: {}
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.templates.INIT:
      return {
        ...state,
        byId: action.templates.reduce((acc, template) => ({ ...acc, [template.templateId]: template }), {})
      };
    case actionTypes.templates.SET:
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.template.templateId]: action.template
        }
      };
    case actionTypes.templates.DELETE:
      const temp = {...state.byId}; 
      delete temp[action.templateId];
      return {
        ...state,
        byId: temp
      };
    default:
      return state;
  }
};

export default reducer;